import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue"

import { storeToRefs } from 'pinia'
import BaseModal from '../wrappers/BaseModal.vue'
import { useModelWrapper } from '../wrappers/helpers/useModelWrapper'
import { useI18n } from 'vue-i18n'
import { useTimers } from '../../store/timers'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalStoreEndVisitWarning',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const value = useModelWrapper(props, emit)
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`${key}`)

const router = useRouter()
const { getActiveChildTimer } = storeToRefs(useTimers())
const navigateToActiveTask = async () => {
  if (getActiveChildTimer.value) {
    await router.push(`/tasks/${getActiveChildTimer.value.data.task_id}`)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(BaseModal, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, {
    title: _withCtx(() => [
      (_unref(getActiveChildTimer))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(label('form.endStore')), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(label('activities.store')), 1)
          ], 64))
    ]),
    content: _withCtx(() => [
      (_unref(getActiveChildTimer))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(label('form.endStoreActiveTask')), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(_toDisplayString(label('form.endCurrentMessage')), 1)
          ], 64))
    ]),
    actions: _withCtx(() => [
      _withDirectives(_createVNode(_component_q_btn, {
        flat: "",
        "no-caps": "",
        class: "text-grey-7",
        label: label('cancel')
      }, null, 8, ["label"]), [
        [_directive_close_popup]
      ]),
      (_unref(getActiveChildTimer))
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            onClick: navigateToActiveTask,
            color: "primary",
            label: `${label('taskProfile.task')}: ${_unref(getActiveChildTimer)?.data.task_id}`
          }, null, 8, ["label"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})